import type { SagaIterator } from 'redux-saga'

import { takeEveryApiCall } from 'syft-acp-core/sagas/helpers'

import { AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_BEGIN } from './action-types'
import { getAgencyCascadeSchedulingPlan } from './api'

export function* saga(): SagaIterator {
  yield takeEveryApiCall(AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_BEGIN, getAgencyCascadeSchedulingPlan)
}
